import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({
    name: Yup.string().required('Field is required'),
  });
};
